export const validation = {
    // Codice Fiscale
    cf: {
        rule: /[A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1}/,
        message: 'CF non valido'
    },
    // Email
    email: {
        rule: /(^[a-zA-Z0-9]+[\._-]{0,9})+([a-zA-Z0-9]+[\._-]{0,9})*@([a-zA-Z0-9]+[-]{0,1})+(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,})$/,
        message: 'Email non valida'
    },
    // Telefono
    phone: {
        rule: /^[0-9]*$/,
        message: 'Telefono non valido'
    },
    // Cap
    cap: {
        rule: /^\d{5}$/,
        message: 'Telefono non valido'
    },
}